import { CreditLineResultStatus } from '@40seas/entities/common';
import { EnumColor } from '@40seas/frontend/common/providers';

export const creditLineStatusColorMapping = {
    [CreditLineResultStatus.Approved]: 'success',
    [CreditLineResultStatus.Declined]: 'error',
    [CreditLineResultStatus.Preapproved]: 'info',
    [CreditLineResultStatus.Pending]: 'default',
    [CreditLineResultStatus.OnHold]: 'default',
} as { [key in CreditLineResultStatus]: EnumColor };

export const creditLineStatusFeildColorMapping = {
    [CreditLineResultStatus.Approved]: 'success',
    [CreditLineResultStatus.Declined]: 'error',
    [CreditLineResultStatus.Canceled]: 'error',
    [CreditLineResultStatus.Preapproved]: 'secondary',
    [CreditLineResultStatus.Pending]: 'neutral',
    [CreditLineResultStatus.OnHold]: 'neutral',
    [CreditLineResultStatus.NotEligeble]: 'neutral',
    [CreditLineResultStatus.Unknown]: 'neutral',
    [CreditLineResultStatus.InReview]: 'info',
    [CreditLineResultStatus.ManualReview]: 'info',
} as { [key in CreditLineResultStatus]: any };
